// @ts-nocheck
import { colors } from '@lmc/common/constants'
import styled from 'styled-components'

export const Box = styled.div`
  align-items: center;
  background: ${colors.white};
  border-radius: 10px;
  justify-content: center;
  margin: 0 auto;
  margin-top: calc(100vh - 85vh - 20px);
  max-height: 70vh;
  overflow: auto;
  padding: 20px;
  position: relative;
  width: 70%;
`

export const CloseIcon = styled.span`
  background: ${colors.white};
  border-radius: 50%;
  cursor: pointer;
  font-size: 20px;
  height: 25px;
  line-height: 20px;
  position: fixed;
  right: calc(15% - 30px);
  text-align: center;
  top: calc(100vh - 85vh - 33px);
  width: 25px;
`

export const PopupBox = styled.div`
  background: #00000050;
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
`

export const SuInvolved = styled.span`
  color: #595959;
  display: block;
  font-size: 12px;
  margin-top: 2px;
`

export const VideoEl = styled.video`
  background: ${colors.background};
  border-radius: 10px;
  cursor: pointer;
  max-height: 60vh;
  width: 100%;
`

export const VideoThumbnail = styled.a`
  background: ${colors.background};
  border-radius: 10px;
  cursor: pointer;
  height: 100px;
  width: 75px;
`

export const Popup = (props) => (
  <PopupBox>
    <Box>
      <CloseIcon onClick={props.handleClose}>x</CloseIcon>
      {props.content}
    </Box>
  </PopupBox>
)
